"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActionIds = void 0;
var ActionIds;
(function (ActionIds) {
    ActionIds["INSERT"] = "1";
    ActionIds["READ"] = "2";
    ActionIds["UPDATE"] = "3";
    ActionIds["DELETE"] = "4";
    ActionIds["LOG OFF"] = "5";
    ActionIds["SUCCESSFUL_LOGON"] = "6";
    ActionIds["UNSUCCESSFUL_LOGON"] = "7";
    ActionIds["MAX_LOGIN_ATTEMPTS_REACHED"] = "8";
    ActionIds["SUCCESSFUL_CHALLENGE_ANSWER"] = "9";
    ActionIds["UNSUCCESSFUL_CHALLENGE_ANSWER"] = "10";
    ActionIds["MAX_CHALLENGE_ANSWER_REACHED"] = "11";
    ActionIds["CHANGE_PASSWORD"] = "33";
    ActionIds["CHANGE_CHALLENGE_ANSWER"] = "34";
    ActionIds["SEND"] = "19216";
    ActionIds["CANCEL"] = "19217";
    ActionIds["NO_ACTION"] = "80757";
    ActionIds["BEGIN_PROXY"] = "88";
    ActionIds["END_PROXY"] = "89";
    ActionIds["PRINTED"] = "12";
    ActionIds["DOWNLOAD"] = "15";
    ActionIds["FAILED_REGISTRATION"] = "95";
    ActionIds["SUCCESSFUL_PROXY"] = "96";
    ActionIds["FAILED_PROXY"] = "97";
    ActionIds["REJECTED_TERMS"] = "98";
    ActionIds["SUCCESSFUL_REGISTRATION"] = "94";
    ActionIds["ACCEPTED_TERMS"] = "99";
    ActionIds["EMAIL_RECEIVED"] = "65";
    ActionIds["EMAIL_SENT"] = "66";
})(ActionIds || (exports.ActionIds = ActionIds = {}));
//# sourceMappingURL=action-ids.enum.js.map